import { useEffect, useState } from 'react';

import TituloSessao from '../componentes/TituloSessao';
import SelectTipoRelatorioControlled from '../componentes/SelectTipoRelatorioControlled';
import SelectMetricaIndicadorControlled from '../componentes/SelectMetricaIndicadorControlled';
import InputMes from '../componentes/DataMesControlled/index.js';

import { geraRelatorio } from '../servicos/servicosEmRotasPrivadas/relatorios';
import { relatorioConfig } from '../config/reportsConfigParametros.js';

import toast from 'react-hot-toast';

function GerarRelatorios() {

    console.log('#### Iniciando GerarRelatorios ####');

    let componentesParametroExtracao = null;
    const parametrosQueryInit = {
        mesReferencia: null,
        dataInicio: null,
        dataFim: null,
        metricaCodigo: null
    };

    const [tipoRelatorio, setTipoRelatorio] = useState(null);
    const [parametrosDaExtracao, setParametrosDaExtracao] = useState(parametrosQueryInit);

    if (tipoRelatorio) {
        componentesParametroExtracao = relatorioConfig[tipoRelatorio.codigo];
    }

    useEffect(() => {
        setParametrosDaExtracao(parametrosQueryInit);
    }, [tipoRelatorio]);

    const componentMap = {
        mes: InputMes,
        select: SelectMetricaIndicadorControlled
    };

    function handleChange(field, value) {
        setParametrosDaExtracao(prev => ({
            ...prev,
            [field]: value
        }))
    };

    async function getRelatorio() {

        if (tipoRelatorio.tipo_filtro === 'MES') {
            if (!parametrosDaExtracao.mesReferencia) {
                toast.error('Selecione o Mês de Referência para gerar o relatório.')
                return
            }
        } else if (tipoRelatorio.tipo_filtro === 'PERIODO') {
            if (!parametrosDaExtracao.dataInicio || !parametrosDaExtracao.dataFim) {
                toast.error('Selecione o mês inicial e o mês final para gerar o relatório.')
                return
            }
        } else {
            toast.error('Tipo de período inválido!')
            return
        }

        if (tipoRelatorio) {
            try {
                geraRelatorio(tipoRelatorio, parametrosDaExtracao)
            } catch (error) {
                console.error(error);
                toast.error(error.message)
            }
        } else {
            toast.error('Selecione o tipo de relatório desejado')
        }
    }

    return (
        <div className='container'>
            <TituloSessao titulo='Gerar Relatórios' barraDecorativa={false} />
            <div className='d-flex flex-column div-com-borda p-3 gap-2'>
                <div className='d-flex flex-column gap-2 col-4'>
                    <label>Tipo de Relatório</label>
                    <SelectTipoRelatorioControlled
                        id='select-tipo-relatorio'
                        value={tipoRelatorio?.codigo}
                        onChange={(e) => setTipoRelatorio(e)}
                    />
                </div>
                <div className='d-flex flex-column gap-2'>
                    <div className='d-flex gap-2'>
                        {componentesParametroExtracao &&
                            componentesParametroExtracao.toRender.map((field) => {
                                const Component = componentMap[field.type];
                                return (
                                    <div key={field.name}>
                                        <label htmlFor={field.name}>
                                            {field.label}
                                        </label>
                                        <Component
                                            key={field.name}
                                            label={field.label}
                                            name={field.name}
                                            value={parametrosDaExtracao[field.name]}
                                            onChange={(value) => handleChange(field.name, value)}
                                            {...field.extraProps}
                                        />
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <button
                    className='btn btn-primary'
                    onClick={getRelatorio}
                >
                    GERAR
                </button>
            </div>
        </div>
    );
}

export default GerarRelatorios
